import { Routes } from "@angular/router";
import { UsersComponent } from "./users.component";
import { AddEditBillerCollectorComponent } from "./components/add-edit-biller-collector/add-edit-biller-collector.component";
import { RoleGuard } from "../../core/guards/role/role.guard";
import { UserRole } from "../../shared/enums/userRoles.enum";

export const usersRoutes: Routes = [
  {
    path: "",
    children: [
      {
        path: "",
        component: UsersComponent,
        canActivate: [RoleGuard],
        data: { roles: [UserRole.Admin, UserRole.Manager, UserRole.PowerUse] },
      },
      {
        path: "add-biller-collector",
        canActivate: [RoleGuard],
        data: { roles: [UserRole.Admin, UserRole.Manager, UserRole.PowerUse] },
        component: AddEditBillerCollectorComponent,
      },
    ],
  },
];
